<template>
  <v-container fluid pa-0 ma-0>
    <v-layout row wrap class="ma-0">

      <v-toolbar class="pa-0 ma-0 toolbar-padding"
                 color="white" flat dense fixed app>
        <v-btn small flat icon @click="$router.go(-1)">
          <v-icon size="24px">$vuetify.icons.navArrowLeft</v-icon>
        </v-btn>
        <h3 class="display-2" style="margin-bottom: 2px">보유쿠폰</h3>
      </v-toolbar>

      <v-flex xs12>
        <v-card tile class="pa-0 card-shadow">
          <v-card-title class="px-3 justify-space-between" style="padding-top: 12px; padding-bottom: 12px;">
            <span style="font-weight: 700; font-size: 16px; letter-spacing: -0.3px; color: black;">
              보유중인 쿠폰 <span style="color: #ec2f54;">{{ totalCount }}</span>장
            </span>
            <v-btn flat small color="#ec2f54"
                   @click.stop="dialog = true"
                   class="my-0 ml-0"
                   style="min-width: 0; font-size: 16px; letter-spacing: -0.3px; margin-right: -8px;">
              코드로 등록하기
            </v-btn>
          </v-card-title>
        </v-card>
      </v-flex>

      <template v-if="coupons.length">
        <v-flex xs12 v-for="(coupon, index) of coupons" :key="index" class="mt-2 px-0">
          <v-card tile class="pa-0 card-shadow">
            <v-layout row>
              <v-flex xs8 pa-3 class="text-xs-left">
                <div style="font-size: 16px; letter-spacing: -0.3px; color: black;">{{ coupon.category.name }}</div>
                <div v-if="coupon.category.type !== 'free'"
                     style="font-size: 20px; letter-spacing: -0.3px; color: black; font-weight: 700;"
                     class="mb-2">
                  {{ couponValue(coupon.category.type, coupon.category.amount) }} 할인 쿠폰
                </div>
                <div v-else
                     style="font-size: 20px; letter-spacing: -0.3px; color: black; font-weight: 700;"
                     class="mb-2">
                  전액 할인 쿠폰
                </div>
<!--                <div>일부 상품 제외</div>-->
                <div style="font-size: 12px; color: black;">{{ couponDate(coupon.start_at, coupon.end_at) }}</div>
              </v-flex>
              <v-divider vertical style="border-left: 5px dotted #eaeaea; border-right: 0; margin: 14px 0;"></v-divider>
              <v-flex xs4 class="align-center justify-center" style="display: flex; flex-direction: column">
                <div style="font-size: 20px; letter-spacing: -0.3px; color: #ec2f54; font-weight: 700;">{{ couponValue(coupon.category.type, coupon.category.amount) }}</div>
                <div style="font-size: 12px; color: #707070;">{{ couponPeriod(coupon.end_at) }}일 남음</div>
              </v-flex>
            </v-layout>
          </v-card>
        </v-flex>
      </template>

      <template v-else>
        <v-flex style="color: #9b9b9b;" class="my-5">
          <v-layout column justify-center>
            <v-img :src="require('@/assets/img/yuni-no-coupon.png')" width="131px" class="mx-auto mb-3"></v-img>
            <div class="mb-3">보유하고 있는 쿠폰이 없습니다.</div>
            <div>
              다양한 이벤트에 참여해<br>
              쿠폰<v-icon size="20px">$vuetify.icons.coupon</v-icon>을 받아보세요.
            </div>
          </v-layout>
        </v-flex>
      </template>

      <v-dialog v-model="dialog" fullscreen hide-overlay transition="dialog-bottom-transition">
        <v-card flat>
          <v-toolbar class="pa-0 ma-0 toolbar-padding toolbar-shadow"
                     color="white" flat dense fixed>
            <v-btn small flat icon @click="dialog = false">
              <v-icon size="16px">$vuetify.icons.cancel</v-icon>
            </v-btn>
            <h3 class="display-2" style="margin-bottom: 2px">코드로 등록하기</h3>
          </v-toolbar>

          <v-card width="100%" flat class="pt-5" color="#f8f8f8">
            <v-layout column align-center style="background-color: white; padding-top: 32px;" mt-2>
              <img :src="`${$baseUrl}/static/img/icon-coupon.png`" style="width: 64px; height: 64px; flex-shrink: 0;">
              <h1 class="my-4" style="font-size: 26px; letter-spacing: -0.5px; color: #4a4a4a;">쿠폰을 등록하세요!</h1>
              <v-text-field solo flat
                            ref="code"
                            v-model="code"
                            :error-messages="errorMessages"
                            placeholder="쿠폰 코드를 입력하세요."
                            class="input-holder-outlined mb-3">
              </v-text-field>
              <v-btn dark depressed color="#4a4a4a"
                     class="mt-3"
                     @click="submit"
                     style="height: 42px; border-radius: 5px; font-size: 14px; letter-spacing: -0.2px; font-weight: 700;">
                쿠폰 등록
              </v-btn>
            </v-layout>
          </v-card>

        </v-card>
      </v-dialog>

    </v-layout>
  </v-container>
</template>

<script>
  import { mapActions } from 'vuex';
  import { intToCommaString } from '@/util/util';

  export default {
    name: 'Coupons',
    data () {
      return {
        dialog: false,
        errorMessages: [],
        code: '',
        coupons: [],
        page: 1,
        maxPage: 2,
        totalCount: 0,
      };
    },
    created () {
      this.selectCoupons(this.page).then(response => {
        this.SELECT_COUPONS(response);
        this.page++;
      }).catch(err => {
        console.error(err);
      });
    },
    watch: {
      code () {
        this.errorMessages = [];
      },
    },
    methods: {
      ...mapActions('product', [ 'selectCoupons', 'enrollCoupon' ]),
      couponValue (type, amount) {
        if (type === 'rate') return `${amount}%`;
        else return `${intToCommaString(amount)}원`;
      },
      couponDate (startAt, endAt) {
        return `${new Date(startAt).toLocaleDateString()} ~ ${new Date(endAt).toLocaleDateString()}`;
      },
      couponPeriod (endAt) {
        return Math.floor((endAt - new Date().getTime()) / (3600000 * 24));
      },
      SELECT_COUPONS (response) {
        this.maxPage = response.max_page;
        this.totalCount = response.total_count;
        response.req_page === 1 ? this.coupons = response.data : this.coupons.push(...response.data);
      },
      submit () {
        if (!this.errorMessages.length) {
          this.enrollCoupon(this.code).then(response => {
            this.coupons.unshift(response.data);
            this.totalCount++;
            this.dialog = false;
          }).catch(err => {
            console.error(err);
            switch (err.response.data.message.code) {
              case 'category_not_found':
                this.errorMessages.push('해당하는 쿠폰을 찾을 수 없습니다.');
                break;
              case 'coupon_period_expired':
                this.errorMessages.push('지급기한이 경과한 쿠폰입니다.');
                break;
              case 'coupon_limit_exceeded':
                this.errorMessages.push('선착순 지급이 완료되어 더이상 받을 수 없는 쿠폰입니다.');
                break;
              case 'already_enrolled':
                this.errorMessages.push('이미 보유중인 쿠폰입니다.');
                break;
              case 'coupon_no_available':
                this.errorMessages.push('이미 사용되었거나 기한이 만료된 쿠폰입니다.');
                break;
              case 'coupon_too_early':
                this.errorMessages.push('아직 등록할 수 없는 쿠폰입니다.');
                break;
              default:
                this.errorMessages.push('오류가 발생했습니다. 잠시 후 다시 시도해 보세요.');
                break;
            }
          });
        }
      },
    }
  }
</script>

<style lang="scss" scoped>
  /deep/.toolbar-shadow .v-toolbar__content {
    box-shadow: 0 2px 3px map-get($colors, background-shadow);
  }

  /deep/.toolbar-padding .v-toolbar__content {
    padding: 0 10px 0 16px;
  }

  /deep/.card-shadow {
    box-shadow: 0 2px 3px map-get($colors, background-shadow);
  }

  /deep/.input-holder-outlined {
    .v-input__slot {
      border: 1px solid #ec2f54;
      border-radius: 36px !important;
      box-shadow: 0 10px 10px 0 rgba(#cdcdcd, 0.25);

      width: 248px;
      height: 73px;

      input {
        text-align: center;
        font-size: 16px;
        font-weight: 700;
        letter-spacing: -0.3px;
        color: #4a4a4a;
      }
    }

    .v-text-field__details {
      text-align: center;
    }

    &.error--text {
      input {
        text-decoration: underline;
        text-decoration-color: #ec2f54;
      }
    }
  }
</style>
